
/*
 * Load all widgets simultaneously for faster loading of widgets data
 */
async function getWidgets (widgets) {

    const self = this;
    const widgetsList = [];
    // const widgetMap = {};

    async function loadWidget (widgetId, callback) {
        const widget = await self.getWidget(widgetId);
        // widgetMap[widgetId] = widget;
        widgetsList.push(widget);
        callback();
    }

    return new Promise((resolve) => {
        function widgetLoaded () {
            if (widgetsList.length >= widgets.length) {
                resolve(widgetsList);
            }
            /*
            const keys = Object.keys(widgetMap);
            if (keys.length >= widgets.length) {
                for (let i = 0; i < widgets.length; i++) {
                    const key = widgets[i];
                    const widget = widgetMap[key];
                    widgetsList.push(widget);
                }
                resolve(widgetsList);
            }
            */
        }

        for (let i = 0; i < widgets.length; i++) {
            loadWidget(widgets[i], widgetLoaded);
        }
    });
}

export default getWidgets;
